import React from "react";
import { NavLink } from "react-router-dom";

import IconWithCounter from "@/components/icon-with-counter";
import { Icon } from "@/components/ui";
import { cn } from "@/utils/cn";

interface ThumbNavigationLinkProps {
  count?: number;
  countMax?: number;
  icon: string;
  activeIcon?: string;
  text: string | React.ReactElement; // TODO: deprecate
  to: string;
  /** Styles the link visually. */
  theme?: "secondary" | "default";
}

const ThumbNavigationLink = ({
  count,
  countMax,
  icon,
  activeIcon,
  to,
  theme = "default",
}: ThumbNavigationLinkProps) => {
  const isCurrentPath = (): boolean => {
    if (!to) {
      return false;
    }

    const exactMatch = location.pathname === to;
    const beginningMatch = location.pathname.startsWith(to);
    return exactMatch || (to === "/" ? false : beginningMatch);
  };

  const active = isCurrentPath();

  return (
    <NavLink
      to={to}
      className="flex flex-1 flex-col items-center space-y-1 px-2 py-4 text-lg"
    >
      {count !== undefined ? (
        <IconWithCounter
          src={activeIcon && active ? activeIcon : icon}
          className={cn("size-5 text-gray-900 dark:text-gray-100", {
            "text-secondary-500 dark:text-secondary-500":
              active && theme === "secondary",
          })}
          count={count}
          countMax={countMax}
        />
      ) : (
        <Icon
          src={activeIcon && active ? activeIcon : icon}
          className={cn("size-5 text-gray-900 dark:text-gray-100", {
            "text-secondary-500 dark:text-secondary-500":
              active && theme === "secondary",
          })}
        />
      )}
    </NavLink>
  );
};

export default ThumbNavigationLink;
